<template>
  <Card class="trade-order">
    <template slot="header">
      <div class="header flex align-center">
        <a class="pointer title mar-r5"> <span>企业交易看板</span> </a>
        <div class="pointer flex items-center" v-if="!purchaseAuthority">
          <el-tooltip placement="bottom" effect="dark" content="抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限">
            <i class="el-icon-warning-outline gray6 f18 mar5-l"></i>
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="items">
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ shoppingNum || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>进货车</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.dzfOrderNum || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待支付</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.refundStatusCount || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>售后</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus2 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待发货</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus3 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待收货</span>
      </a>
      <a class="gray6 item">
        <span class="num" v-if="purchaseAuthority">{{ orderInfo.orderStatus4 || 0 }}</span>
        <span class="num" v-else>****</span>
        <span>待评价</span>
      </a>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
@import "../../index.scss";
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  computed: mapState({
    userIdentity: (state) => state.app.userIdentity,
    purchaseAuthority: (state) => state.app.purchaseAuthority,
  }),

  data() {
    return {
      origin: process.env,
      orderInfo: {},
      shoppingNum: 0,
    };
  },

  mounted() {
    if (this.purchaseAuthority) {
      // 查询用户进货车商品数量与商品总金额
      this.$store.dispatch("trade/shoppingCart").then((data) => {
        if (data.cartCount > 99) {
          this.shoppingNum = "99+";
        } else {
          this.shoppingNum = data.cartCount;
        }
      });
      // 获取订单
      this.$store.dispatch("trade/orderNumsList").then((data) => {
        this.orderInfo = data || {};
      });
    }
  },
};
</script>
